import React from 'react';
import {Grid} from '@material-ui/core';
import classNames from 'classnames';
import CustomKeyboardDateTimePicker from '../../../components/KeyboardDateTimePicker/KeyboardDateTimePicker';
import Button from '../../../components/Button/Button';
import {useStyles, VoicemailsFilterFormProps} from "../utils/VoicemailsFilterForm.utils";


const VoicemailsFilterForm: React.FC<VoicemailsFilterFormProps> = (
    {
        values,
        errors,
        classes,
        t,
        userDateTimeFormat,
        handleSubmit,
        setFieldError,
        onFromChange,
        onTillChange,
        onSearchClick,
        dataTestId = "voicemails-form"
    }) => {

    const cx = classes ?? useStyles();


    return (

        <form
            onSubmit={handleSubmit}
            autoComplete="off"
            data-testid={dataTestId}
        >
            <Grid
                item
                className={classNames(
                    cx.itemsContainer,
                    cx.filterSeparation,
                )}
            >
                <CustomKeyboardDateTimePicker
                    id="from"
                    label={t('common:fromDate')}
                    value={values.from}
                    onChange={onFromChange}
                    dataQa={'voicemails-filter-from'}
                    dataTestId={'voicemails-filter-from'}
                    userDateTimeFormat={userDateTimeFormat}
                    helperText={errors.from}
                    setFieldError={setFieldError}
                    className={cx.timePicker}
                    skipPermission
                />
                <CustomKeyboardDateTimePicker
                    id="till"
                    label={t('common:toDate')}
                    value={values.till}
                    onChange={onTillChange}
                    dataQa={'voicemails-filter-till'}
                    dataTestId={'voicemails-filter-till'}
                    userDateTimeFormat={userDateTimeFormat}
                    helperText={errors.till}
                    setFieldError={setFieldError}
                    className={cx.timePicker}
                    skipPermission
                />
                <Button
                    primary
                    accent
                    type="submit"
                    dataQa="voicemails-search"
                    className={cx.button}
                    skipPermission
                >
                    {t('common:search')}
                </Button>
            </Grid>
        </form>
    )
};

export default VoicemailsFilterForm;
